export function findCityById(id) {
    return axios({
        url: `/api/directories/cities/get-by-id`,
        method: 'get',
        params: {
            id: id
        },
    });
}
export function getMark(mark) {
    return axios({
        url: `/api/directories/cars/find-mark`,
        method: 'get',
        params: {
          name: mark
        },
    });
}
